import React from 'react'
import cn, { Argument as ClassName } from 'classnames'
import styled from 'styled-components'

export type TooltipIconProps = {
    size?: number
    className?: ClassName
    style?: React.CSSProperties
}

const SIcon = styled.svg`
    cursor: pointer;
    transition: 0.2s all ease;

    &:hover {
        opacity: 50%;
    }
`

export const TooltipIcon = React.memo(function TooltipIcon({
    className,
    style,
    size = 16,
}: TooltipIconProps): React.ReactElement {
    return (
        <SIcon
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 26 26"
            fill="none"
            className={cn(className)}
            style={style}
        >
            <path
                d="m22.946 6.29-.797.537A10.959 10.959 0 0 1 24.04 13c0 6.086-4.954 11.04-11.04 11.04-6.086 0-11.04-4.954-11.04-11.04C1.96 6.914 6.914 1.96 13 1.96c2.755 0 5.386 1.018 7.42 2.87l.644-.71A11.92 11.92 0 0 0 13 1C6.386 1 1 6.386 1 13s5.386 12 12 12 12-5.386 12-12c0-2.4-.71-4.723-2.054-6.71Z"
                fill="#000"
                stroke="#000"
                strokeWidth={0.5}
            />
            <path
                d="M14.68 12.693c1.027-.624 1.526-1.479 1.526-2.621 0-1.747-1.267-2.928-3.158-2.928-1.796 0-3.072 1.085-3.236 2.736h1.076c.172-1.411 1.257-1.92 2.16-1.92 1.248 0 2.15.854 2.15 2.035 0 .883-.46 1.642-1.296 2.15-1.008.615-1.67 1.172-1.728 3.265h.998c.048-1.364.423-2.036 1.508-2.717ZM13.172 17.934h-.998v1.603h.998v-1.603Z"
                fill="#000"
                stroke="#000"
                strokeWidth={0.5}
            />
        </SIcon>
    )
})
